module.exports = __webpack_public_path__ + "7b89a08272ba26f33c6023c73c41e3ab.svg";